import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { storageKeys } from 'config/settings.json';

import Progress from 'components/Progress';
import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

const shareAnalytics = (name, value) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      APIHandler.trackEvent(appId, email, 'levelii', name, value, value).then(() => undefined);
    });
  });
};
export default class SubAppButton extends Component {
  constructor(props) {
    super(props);

    const { src, customName, appId } = this.props;

    let newSrc = src;
    const name = customName.length > 0 ? customName : 'Icon-180';
    if (newSrc.length === 0) {
      if (appId > 500) {
        newSrc = `https://front.travpromobile.com/${appId}/logo_white.png`;
      } else {
        newSrc = `https://cdn.travpromobile.com/apptool/app/${appId}/images/${name}.png`;
      }
    }
    this.state = {
      appId,
      lang: '',
      pageId: 0,
      src: newSrc,
      redir: '',
      firstName: '',
      lastName: '',
    };
  }

  componentDidMount() {
    this.loadUserData();
  }

  loadUserData() {
    StorageHandler.load(storageKeys.lang).then(({ langFile: lang }) => {
      this.setState({ lang });
    });
    StorageHandler.load(storageKeys.user).then((res) => {
      this.setState({
        firstName: res.first_name,
        lastName: res.last_name,
      });
    });
  }

  render() {
    const { src, firstName, lastName, lang } = this.state;
    const { appId, progress, name, type, chapterId, email, locked, level, pageId, uri, numChapters, backgroundImage } =
      this.props;

    const appURL = window.location.origin;

    let buttonText;
    switch (progress) {
      case 100:
        buttonText = i18n.translate('trainingScreens.restart');
        break;
      case undefined:
      case 0:
        buttonText = i18n.translate('trainingScreens.start');
        break;
      default:
        buttonText = i18n.translate('trainingScreens.continue');
    }

    if (type !== 'training') {
      buttonText = i18n.translate('trainingScreens.review');
    }

    let programUrl = uri;
    if (level === 'ii' && type === 'retain') {
      programUrl = `https://academy.travpromobile.com/retain/${appId}/${email}/${chapterId}/${pageId}/${
        type === 'training' ? 'true' : ''
      }/true/?lang=${lang}&redirurl=${appURL}/main/${type}`;
    } else if (level === 'ii') {
      programUrl = `https://academy.travpromobile.com/${type}/${appId}/${email}/${chapterId}/${pageId}/${
        type === 'training' ? 'true' : ''
      }/true/?lang=${lang}&redirurl=${appURL}/main/${type}`;
    }

    if (type !== 'training' && level === 'ii') {
      programUrl = `https://academy.travpromobile.com/retain/${appId}/${email}/${chapterId}/0/true/true?lang=${lang}&redirurl=${appURL}/main/${type}`;
    }

    const badgeUrl = `https://stack.travpromobile.com/download.php?name=${name}.png&url=https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=${appId}`;

    if (locked) {
      return (
        <div className="subApp__Card" key={chapterId}>
          {locked && (
            <div className="subApp__Card--locked">
              {type === 'training' ? (
                <>
                  <h4>{name}</h4>
                  <p>{i18n.translate('trainingScreens.unlockPartners')}</p>
                </>
              ) : (
                <p>{i18n.translate('trainingScreens.unlockRetain', { name })}</p>
              )}
              <FontAwesomeIcon icon={['fas', 'lock']} />
            </div>
          )}
          {backgroundImage && (
            <img
              src={`${backgroundImage.replace('s3.amazonaws.com/developertool', 'travprocdn.imgix.net')}?width=500`}
              className="subApp__Card--backgroundImage"
            />
          )}
          <div className="subApp__Card--content">
            {!locked && <div className="overlay gradient" />}
            {!locked && <img src={src} className="logo" />}
          </div>
        </div>
      );
    }
    return (
      <div className="subApp__Card" key={chapterId}>
        <a
          href={programUrl}
          onClick={() => {
            shareAnalytics('open-training', chapterId);
          }}
          {...(numChapters > 1 ? { target: '_blank' } : {})}
        >
          {locked && (
            <div className="subApp__Card--locked">
              <h4>{name}</h4>
              <p>{i18n.translate('trainingScreens.unlockSubtitle')}</p>
              <FontAwesomeIcon icon={['fas', 'lock']} />
            </div>
          )}
          {backgroundImage && (
            <img
              src={`${backgroundImage.replace('s3.amazonaws.com/developertool', 'travprocdn.imgix.net')}?width=500`}
              className="subApp__Card--backgroundImage"
            />
          )}
          <div className="subApp__Card--content">
            <div className="overlay gradient" />
            {!locked && <img src={src} className="logo" />}
            <button>{buttonText}</button>
            <div className="subApp__Card--start">
              {type === 'training' && <Progress id={`SubAppButton_${src}`} value={progress} />}
            </div>
          </div>
        </a>
        {firstName && progress >= 100 && numChapters === 1 && (
          <a href={badgeUrl} className="badge">
            <FontAwesomeIcon icon={['far', 'file-certificate']} /> {i18n.translate('general.downloadBadge')}
          </a>
        )}
      </div>
    );
  }
}

SubAppButton.propTypes = {
  appId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  email: PropTypes.string,
  customName: PropTypes.string,
  src: PropTypes.string,
  locked: PropTypes.bool,
  level: PropTypes.string,
  size: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
  chapterId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  progress: PropTypes.number,
  name: PropTypes.string,
  uri: PropTypes.string,
  numChapters: PropTypes.number,
  percentageCompleted: PropTypes.number,
};

SubAppButton.defaultProps = {
  appId: -1,
  chapterId: -1,
  customName: '',
  src: '',
  locked: false,
  level: '',
  size: { height: 150, width: 60 },
  pageId: 0,
  email: '',
  name: 'Level II Chapter',
  comingSoon: false,
  progress: 0,
  numChapters: 1,
  uri: '',
  percentageCompleted: 0,
};
